module.exports = __webpack_public_path__ + "static/img/demoa.a26a2dc7.png";